@if (incomeTaxEntity$ | async) {
  <form (change)="saveForm()" [formGroup]="formGroup">
    <snelstart-ui-date-form-control class="custom-input-250 "
                                    formControlName="datumTrouwen"
                                    id="datumTrouwen"
                                    label="Datum trouwen in {{ (incomeTaxEntity$ | async)?.year}}"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-date-form-control class="custom-input-250 "
                                    formControlName="datumScheiding"
                                    id="datumScheiding"
                                    label="Datum echtscheiding in {{ (incomeTaxEntity$ | async)?.year}}"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-date-form-control class="custom-input-250 "
                                    formControlName="datumOverlijdenPartner"
                                    id="datumOverlijdenPartner"
                                    label="Overlijdensdatum partner in {{ (incomeTaxEntity$ | async)?.year}}"
    >
    </snelstart-ui-date-form-control>

    <div formGroupName="periodeIngeschrevenOpZelfdeAdres">
      <snelstart-ui-date-form-control class="custom-input-250"
                                      formControlName="begindatum"
                                      id="begindatum"
                                      label="Begin inschrijving zelfde adres in {{ (incomeTaxEntity$ | async)?.year}}"
      >
      </snelstart-ui-date-form-control>
      <snelstart-ui-date-form-control class="custom-input-250"
                                      formControlName="einddatum"
                                      id="einddatum"
                                      label="Einde inschrijving zelfde adres in {{ (incomeTaxEntity$ | async)?.year}}"

      >
      </snelstart-ui-date-form-control>
    </div>

    <snelstart-ui-select-form-control [options]="optionsJaNeeVoorwaarden"
                                      [required]=true
                                      class="custom-input-250"
                                      formControlName="voldaanAanFiscaalPartnerschapVoorwaarden"
                                      label="Is er voldaan aan een voorwaarde voor fiscaal partnerschap in {{ (incomeTaxEntity$ | async)?.year}}?"
    >
    </snelstart-ui-select-form-control>

    @if (formGroup.controls.voldaanAanFiscaalPartnerschapVoorwaarden) {
      <snelstart-ui-select-form-control (change)="saveForm()"
                                        [options]="optionsJaNee"
                                        [required]=true
                                        class="custom-input-250"
                                        formControlName="kiestVoorHeleJaarPartnerschap"
                                        label="Keuze voor heel jaar fiscaal partner"
      >
      </snelstart-ui-select-form-control>
    }
  </form>
}
